export default __webpack_public_path__ + "static/media/windows-server.78dadffa.svg";